// sets the cookie to delay the newsletter modal until page 2
import * as constants from '../../../common/js/templates/newsletter_modal/constants';
import Cookies from 'js-cookie';
import { mapState } from 'vuex';
import { executeModal } from '../../js/templates/newsletter_modal/modal';

export default {
    name: 'adivare-rentals-list',
    props: [
        'title',
        'path',
        'call_to_action_link',
        'app_shortname',
    ],
    methods: {
        watchFold() {
            if ((window.innerHeight * 0.5) < window.scrollY) {
                Cookies.set(constants.newsletterModalProgress, constants.showWithDelay, {
                    expires: 1,
                    path: '/',
                    secure: true,
                    sameSite: 'strict'
                });
                executeModal();
                window.removeEventListener('scroll', this.watchFold);
            }
        },
    },
    computed: {
        ...mapState({
            rentals: state => state.houses,
            filters: state => state.filters,
            user: state => state.userId,
            waitingForHouses: state => state.pending.houses,
            pageNumber: state => state.filters.page,
            houseCount: state => +state.houseCount,
            resultsPerPage: state => state.filters.resultsPerPage,
        }),
        lastPage() {
            return Math.ceil(this.houseCount / this.resultsPerPage);
        },
        newsLetterProgressModalCookie() {
            return Cookies.get(constants.newsletterModalProgress);
        }
    },
    watch: {
        lastPage() {
            if (this.newsLetterProgressModalCookie === constants.modalShown) return;
            if (1 === this.lastPage) window.addEventListener('scroll', this.watchFold);
        },
        waitingForHouses(newValue) {
            if (1 !== this.pageNumber && false === newValue) executeModal();
        }
    },
    beforeMount() {
        this.$store.dispatch('requestNewHouses');
    },
    beforeUpdate() {
        $('[data-select-menu-show]').each(function() {
            $(this).remove();
        });
    },
}
